import { useState } from "react";
import { Eye, EyeOff, Check, X } from "lucide-react";

const RULES = [
  { key: "len", label: "Mínimo 8 caracteres", test: (p) => p.length >= 8 },
  { key: "upper", label: "1 letra mayúscula", test: (p) => /[A-Z]/.test(p) },
  { key: "num", label: "1 número", test: (p) => /[0-9]/.test(p) },
];

export const isStrongPassword = (p) => RULES.every((r) => r.test(p || ""));

export const PASSWORD_POLICY_MSG =
  "La contraseña debe tener mínimo 8 caracteres, al menos 1 mayúscula y 1 número";

export function PasswordInput({ className = "", testid, toggleTestid, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        data-testid={testid}
        type={show ? "text" : "password"}
        className={`${className} pr-10`}
        {...props}
      />
      <button
        type="button"
        data-testid={toggleTestid}
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Ocultar contraseña" : "Mostrar contraseña"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8b7e5e] hover:text-[#1c1a14]"
      >
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
}

export function PasswordStrength({ password }) {
  if (!password) return null;
  return (
    <div data-testid="password-strength" className="mt-1.5 flex flex-wrap gap-x-4 gap-y-1">
      {RULES.map((r) => {
        const ok = r.test(password);
        return (
          <span
            key={r.key}
            className={`inline-flex items-center gap-1 text-[11px] ${
              ok ? "text-emerald-700" : "text-[#8b7e5e]"
            }`}
          >
            {ok ? <Check size={11} /> : <X size={11} />} {r.label}
          </span>
        );
      })}
    </div>
  );
}
